<script setup lang="ts">
import VButton from "@magnit/core/src/components/VButton/VButton.vue";
import VHidden from "@magnit/core/src/components/VHidden/VHidden.vue";
import VIcon from "@magnit/icons/src/components/VIcon/VIcon.vue";
import MenuIcon from "@magnit/icons/src/assets/icons/menu-24.svg";
import { LABEL_MODAL_BUTTON } from "../constants";

defineProps({
  text: {
    type: String,
    default: LABEL_MODAL_BUTTON,
  },
});
const emit = defineEmits<{
  "click:modal-button": [];
}>();

const handleClick = () => emit("click:modal-button");
</script>

<template>
  <section
    class="shop-select__modal-button__outer"
    data-test-id="shops-list-button"
  >
    <VButton
      class="shop-select__modal-button"
      icon-position="left"
      theme="invert"
      @click="handleClick"
    >
      <template #icon>
        <VIcon><MenuIcon /></VIcon>
      </template>
      <VHidden :hide="{ xs: true, m: false }">{{ text }}</VHidden>
    </VButton>
  </section>
</template>

<style lang="postcss" scoped>
.shop-select__modal-button {
  box-shadow: 0 0 10px 0 #00000026;

  &__outer {
    position: absolute;
    z-index: 20;
    display: none;

    @media (--pl-viewport-from-ml) {
      top: 32px;
      left: 32px;
      display: unset;
    }
  }
}
</style>
